import AbstractModel from '../AbstractModel';

class EquipmentModelModel extends AbstractModel {}

export default EquipmentModelModel;
